import { useParams } from 'react-router-dom';
import { actions } from 'pages/documents_v2/config/views';
import { useContext } from 'react';
import { AreaContext } from 'pages/documents_v2/views/edit_area/context/AreaContext';
import { useGetDocument } from 'pages/documents_v2/hooks/useGetDocument';
import { useEntityTemplateParameters } from 'pages/documents_v2/hooks/useEntityTemplateParameters';
import { BooleanParam, useQueryParam } from 'use-query-params';

export function useIsReadOnly(block) {
    const { view } = useParams();
    const { selectedHistoryVersion } = useContext(AreaContext);
    const document = useGetDocument();
    const restrictions = useEntityTemplateParameters(block, 'block', document);
    const [compareBlocksEnabled] = useQueryParam('compare', BooleanParam);

    return (
        view === actions.VIEW ||
        selectedHistoryVersion !== undefined ||
        restrictions?.canChangeContent === false ||
        compareBlocksEnabled === true
    );
}
